import React, {FC} from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {TableWrapper} from '@/components/table/TableWrapper'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'
import {ModalWrapperProps} from '@/components/table/core/_types'
import {Modal} from '@/components/table/modal/Modal'
import {getSales} from '../core/_requests'
import {Columns} from './columns/_columns'
import {FilterForm, initialFilters} from './components/FilterForm'
import {OrderOverview} from './components/Overview'

const Breadcrumbs = BreadcrumbsBuilder([{
  title: 'Home',
  path: '/'
}, {
  title: 'Passtocard',
  path: '/p2c/dashboard',
}])

const ModalWrapper: FC<ModalWrapperProps> = ({itemForUpdate, action}) => {
  return (
    <>
      {itemForUpdate !== undefined && action === 'details' && (
        <Modal title="Order details" maxWidth={800}>
          <OrderOverview/>
        </Modal>
      )}
    </>
  )
}

const ListWrapper = () => (
  <>
    <PageTitle breadcrumbs={Breadcrumbs}>Transactions</PageTitle>
    <TableWrapper
      dataProvider={getSales}
      cols={Columns}
      queryId="P2C_SALES_LIST"
      modals={ModalWrapper}
      lookup={{
        placeholder: 'Search order',
        fields: ['email', 'username', 'code']
      }}
      filters={{
        formFields: FilterForm,
        initialValues: initialFilters
      }}
    />
  </>
)

export default ListWrapper
